import { Injectable } from '@angular/core';

export type CsvRow = Record<
  string,
  string | number | boolean | null | undefined
>;

export interface IExportOptions {
  filename: string;
  title?: string;
  bom?: boolean;
}

@Injectable({ providedIn: 'root' })
export class FileService {
  exportToCsv(data: CsvRow[], options: IExportOptions): void {
    if (!data.length) {
      return;
    }

    const headers = [
      ...data.reduce((headerSet, record) => {
        Object.keys(record).forEach((key) => headerSet.add(key));
        return headerSet;
      }, new Set<string>()),
    ];
    const rows = data.map((record) =>
      headers.map((key) => this.escapeCsvCell(record[key]))
    );

    const csvContent = [
      ...(options.title ? [this.escapeCsvCell(options.title)] : []),
      headers.map((header) => this.escapeCsvCell(header)).join(','),
      ...rows.map((row) => row.join(',')),
    ].join('\n');

    this.downloadFile(
      options.bom ? `\uFEFF${csvContent}` : csvContent,
      this.ensureExtension(options.filename, 'csv'),
      'text/csv;charset=utf-8;'
    );
  }

  private escapeCsvCell(
    value: string | number | boolean | null | undefined
  ): string {
    const stringValue = value?.toString() ?? '';
    const needsQuotes = /[",\n\r]/.test(stringValue);
    const escaped = stringValue.replace(/"/g, '""');
    return needsQuotes ? `"${escaped}"` : escaped;
  }

  private ensureExtension(filename: string, ext: string): string {
    return filename.endsWith(`.${ext}`) ? filename : `${filename}.${ext}`;
  }

  private downloadFile(
    content: string,
    filename: string,
    mimeType: string
  ): void {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  }
}
